import { useCallback } from 'react';

import * as Types from './types';
import { useGenericSend } from '../useGenericSend';

export const useChangePlayerLoginInfo = () => {
    const send = useGenericSend();

    return useCallback((request: Types.IChangePlayerLoginInfoRequest) => send<Types.IChangePlayerLoginInfoRequest>({
        ID: 81112,
        responses: [81114, 81100],
        description: 'Change Player Login Info Request',
        ...request
    }), [send]);
};
